import React from 'react';
import ContactForm from '../components/ContactForm';

const ContactPage = () => {
  return (
    <main className="pt-32 md:pt-56 lg:pt-64">
      <div className="bg-[#04a6df] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-semibold text-white uppercase tracking-tight">
            Kontakt
          </h1>
          <p className="mt-4 text-white/90 text-lg max-w-2xl mx-auto">
            Jeg sidder klar til at besvare dine spørgsmål. Kontakt mig i dag for en uforpligtende snak.
          </p>
        </div>
      </div>
      <ContactForm />
    </main>
  );
};

export default ContactPage;
